import _ from "lodash"

// function that returns true if value is email, false otherwise
export const verifyEmail = (value) => {
  var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (emailRex.test(value)) {
    return true
  }
  return false
}

// verifies if a string has a given length or not
export const verifyLength = (value, length) => {
  if (value.trim().length >= length) {
    return true
  }
  return false
}

// verifies if value contains only numbers
export const verifyNumber = (value) => {
  var numberRex = new RegExp("^[0-9]+(.[0-9]+)?$")
  if (numberRex.test(value)) {
    return true
  }
  return false
}

// verifies if value contains a valid phone number
export const verifyPhoneNumber = (value) => {
  var numberRex = new RegExp(/^05\d{8}$/) // start with 05 & contain 10 digit
  if (numberRex.test(value)) {
    return true
  }
  return false
}

// verifies if value is a valid URL
export const verifyUrl = (value) => {
  try {
    new URL(value)
    return true
  } catch (_) {
    return false
  }
}

// verifies if value is a valid image
export const verifyImage = (value) => {
  return _.get(value, "type", "").includes("image")
}

// set the error message for the input field
export const errorMessage = (validation) => {

  switch (validation) {
    case "number":
      return "Invalid Number"

    case "email":
      return "Invalid Email Address"

    case "password":
      return `At least 8 characters`

    case "confirmPassword":
      return `Passwords not match`

    // case "phone":
    //   return `Invalid phone number (must start with 05 and contain 10 digits)`


    default:
      return `Required`
  }
}

/**
 *
 * ?NOTE: this func not check the password | confirm password fields
 * 
 * @param {object} form
 * @returns {boolean} is all required field are valid & there is no invalid data
 * @returns {object} the form data (to send to DB)
 */
export const isFormValid = (form) => {
  let data = {},
    isFormValid = true

  // check if the all required field value are valid
  _.forEach(form, (field) => {
  console.log("isFormValid -> form", field)

    if (field.stateName === "password" || field.stateName === "confirmPassword") return // continue

    let formValid = isFieldValid(field)

    let {
      stateName
    } = field

    if (!formValid) return (isFormValid = false) // break

    // set the valid data
    if (isFieldWasChanged(field))
      _.set(data, stateName, formValid.value)
      
  })

  return [isFormValid, data]
}

/**
 * check it the field is valid & return the data (state, value),
 * otherwase return false
 *
 * @param {object} field
 * @returns {boolean | object}
 */
let isFieldValid = (field) => {
  let value = _.get(field, "value", null),
    stateName = _.get(field, "stateName"),
    state = _.get(field, "state"),
    required = _.get(field, "required")

  if ((value && state === "has-danger") || (required && _.isEmpty(value))) return false

  // list validation
  let isMulti = _.get(field, "isMulti")
  if (isMulti && required && _.size(value) === 0) return false

  let textType = _.get(field, "textType")
  value = textType === "number" ? parseFloat(value) : value

  return {
    stateName,
    value
  }
}

/**
 * check if the field value was changed or not
 *
 * @param {object} field
 */
let isFieldWasChanged = (field) => {
  let original_value = _.get(field, "original_value"),
    value = _.get(field, "value")

  return !_.isEqual(value, original_value)
}

/**
 * 
 * 
 * @param {object} passField 
 * @param {object} confirmPassField 
 * @returns {string|boolean}
 */
export let passwordChecker = (passField, confirmPassField) => {
  let pass = _.get(passField, "value"),
    original_pass = _.get(passField, "original_value")

  if (pass === original_pass) return false // no changes

  // check if the changed pass match the confirm
  let confirmPass = _.get(confirmPassField, "value")

  if (pass === confirmPass) return pass // the new pass

  return true // not matched
}